import axios from "axios";
import { getENVType } from "./methods"

// let baseURL ='http://ebjqa.zzrcer.com';
// let baseURL = window.location.origin
let obj = getENVType()
let baseURL = process.env.NODE_ENV !== 'production' ? '' :
    obj.url
// 创建一个axios实例
const instance = axios.create({
  baseUrl: baseURL,
  timeout: 10000,
  withCredentials: true,
  headers: {}
});

instance.defaults.headers.post["Content-Type"] = "application/json";
// 添加请求拦截器
instance.interceptors.request.use(config => {
  if (config.method == "get" || config.method == "delete") {
    config.params = {
      ...config.params,
      ts: new Date().valueOf() // 解决IE get请求缓存问题
    };
  }
  return config;
});

// 添加响应拦截器
instance.interceptors.response.use(
  response => {
    // TODO
    let ResponseUserInfo = !response.headers.iris_user_sso_dto_key ? ''
    : response.headers.iris_user_sso_dto_key
    const ResponseHeaders = response.config.headers,
      ResponseUrlName = response.config.url,
      data = response.data,
      sendResponse = {
        sendData:
          response.config.method === "post" && response.config.data
            ? JSON.parse(response.config.data)
            : response.config.params,
        sendURL: response.config.url
      };
    _output({
      title: response.config.url,
      content: {
        ResponseHeaders,
        data,
        sendResponse
      }
    });
  },
  err => {
    console.log("error:::", err);
    window.eventBus.$emit('onError', "v1003",err);//时间超时等异常
    return Promise.reject("请求错误");
  }
);
//线下输出线上关闭
const _output = e => {
  const Debug =
    !!~location.origin.indexOf("http://localhost:") ||
    !!~location.origin.indexOf("http://192.168.") ||
    !!~location.origin.indexOf("http://127.0.0.1:") ||
    !!~location.origin.indexOf("http://0.0.0.0:");
  return (
    Debug &&
    console.log(
      `%ctitle：${e.title}\n%cfrom：${document.title}\n%cdata：%o`,
      "color:#cc7832;border-bottom:1px solid #57a3f3",
      "color:#6a7c4e;border-bottom:1px solid #f7f7f7",
      "color:#d24f4d",
      e.content
    )
  );
};
/**
 * post请求
 *
 */
export const $http = (url, params) => {
  return new Promise((res, rej) => {
    instance
      .post(url, JSON.stringify(params))
      .then(data => {
        res(data);
      })
      .catch(error => {
        rej(error);
      });
  });
};
/**
 * get请求
 *
 */
export const $api = (url, params) => {
  return new Promise((res, rej) => {
    instance
      .get(url, { params: params })
      .then(data => {
        res(data);
      })
      .catch(err => {
        rej(err);
      });
  });
};
